module.exports = "/images/icon-delete.svg?1c9fb117ab7cdcbcd977f3bc5cb5e4f3";